import Vue from "vue";
import VueRouter from "vue-router";
import { i18n } from "@/services/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "public.home",
    component: require("./views/index.vue").default,
    meta: {
      breadcrumb: {
        label: i18n.t("home"),
        icon: "mdi-home",
        meta: "__property"
      }
    },
  },
  {
    path: "/application-files/:application_file/applicant/:email",
    name: "application_files.public.applicant",
    component: require("../shared/applicant/index.vue").default,
  },
  {
    path: "/rent-agent/:rentAgentId",
    name: "rent_agent.index",
    component: require("./views/rentAgent/index.vue").default,
    meta: {
      breadcrumb: {
        parent: "public.home",
        meta: "__property"
      }
    },
  },
  {
    path: "/:slug",
    name: "public.home.show",
    component: require("./views/property/show.vue").default,
    meta: {
      breadcrumb: {
        parent: "public.home",
        meta: "__property"
      }
    },
  }
];


export default new VueRouter({
  routes,
  base: "public",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
